export default "__VITE_ASSET__461af93f__"